import { default as initHeroSwiper } from "./components/maloka-dynamic-hero";
import initBurningCake from "./components/burning-cake";
import "./utils/upload-images";
import initUglyCakesBox from "./components/ugly-cakes-box";
import { addProductToCart, updateCartCount } from "./utils/cart-handler";
import { toppingWithPriceInit } from "./components/topping-with-price";
import { addProductToCartTopping, updateCartCountTopping } from "./utils/cart-handler-topping-price";
import { addCustomCakeToCart } from "./utils/cart-handler-custom-cake";
initHeroSwiper();
document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname === "/collections/all") {
    window.location.href = "/collections/all-products";
  }
  if (document.body.classList.contains('burningcake')) {
    initBurningCake();
    addCustomCakeToCart(); // toppings + additional agrupados en el carrito
  }
  if (document.body.classList.contains('uglycake')) {
    addCustomCakeToCart(); // toppings + additional agrupados en el carrito
  }
  if (document.body.classList.contains('uglycakebox')) {
    initUglyCakesBox();
  }
  if (document.body.classList.contains('topping-with-price')) {
    toppingWithPriceInit();
    addProductToCartTopping();
    window.updateCartCount = updateCartCountTopping;
  }
  if (document.body.classList.contains('default-template')) {
    addProductToCart(); // Asignamos eventos para agregar productos
    window.updateCartCount = updateCartCount; // Asignamos la función para actualizar el contador del carrito

    // Selección de productos adicionales
    var nonFoodSelectors = document.querySelectorAll('input[name="properties[Additional]"]');
    var nonFoodInputId = document.querySelector('input[name="additionalProductId"]');
    nonFoodSelectors.forEach(function (selector) {
      selector.addEventListener('change', function () {
        nonFoodInputId.value = selector.dataset.variant;
      });
    });
  }
});